import BankAccountsSelect from "./BankAccountsSelect";

export default BankAccountsSelect;
